import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class PermissionsAdd extends Component{
	render(){
		const {permissions} =this.props;
		let pc = _.find(permissions.permissions, (o) => {return o==='Create'});
		return (
			pc ?
				<p>
					<NavLink to={`/permisos/crear`} className="button is-small is-inm-purple">{'Agregar permiso'}</NavLink>
				</p>
				:''
		)
	}
}

export default SecureLayout(PermissionsAdd);


// WEBPACK FOOTER //
// ./src/elements/permissions/widget/permissions_add.jsx